<template>
  <div class="blog-page">
    <HeroSection
      v-model:searchQuery="searchQuery"
      :title="heroTitle"
      :subtitle="heroSubtitle"
      :searchLabel="searchLabel"
      :heroSubtitleMob="heroSubtitleMob"

    />
    <BlogListSection
      :searchQuery="searchQuery"
      :items="allBlogs"
      :status="status"
      :filters="filters"
      :activeFilter="activeFilter"
      v-model:page="page"
      :totalItems="totalBlogs"
      :limit="limit"
      :showFilters="true"
      :cardComponent="BlogCard"
      :setFilter="setFilter"
      :fetchItems="fetchBlogs"
      :routePath="routePath"
      :showReadTime="true"
      @clearSearchInput="clearSearchInput"
      :notFoundHint="notFoundHint"

    />
    <Newsletter />
    <GetInTouch :backgroundColor="'#DEF3FF'" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import blogService from '@/services/API/blogService';
import HeroSection from '../partials/HeroSection.vue';
import BlogListSection from '../partials/CardListSection.vue';
import Newsletter from '../partials/Newsletter.vue';
import GetInTouch from './../../service/components/GetInTouch.vue';
import GenericCard from '../partials/Card.vue';

const BlogCard = GenericCard; // Alias for clarity

const searchQuery = ref('');
const heroTitle = ref('Blogs and Insights');
const heroSubtitle = ref(
  'Explore insights on business, technology, and professional growth—curated </br>to help you stay ahead in a fast-changing digital world'
);
const heroSubtitleMob = ref("Explore insights on business, technology, and professional growth—curated to help you stay ahead in a fast-changing digital world");
const searchLabel = ref('Search Blogs and Insights');
const routePath = ref('/blogs-and-insights'); // Define the route path

const notFoundHint = ref("We couldn't find any blogs matching your search. Try a different keyword or explore our latest insights instead.");
const allBlogs = ref([]);
const status = ref('loading');
const activeFilter = ref('all');
const page = ref(1);
const totalBlogs = ref(0);
const limit = 12;
const filters = ref([
  { id: 'all', label: 'All Posts' },
  { id: 'Industry Insight', label: 'Industry Insight' },
  { id: 'Company + Product', label: 'Company + Product' },
  { id: 'Customer + Partner', label: 'Customer + Partner' },
]);

const totalPages = computed(() => Math.ceil(totalBlogs.value / limit));

const fetchBlogs = async (key = searchQuery.value) => {
  try {
    status.value = 'loading';
    console.log("page: ", page.value)
    const res = await blogService.listAllBlogs(
      activeFilter.value,
      key,
      page.value - 1
    );
    if (res.status === 200) {
      allBlogs.value = res.data.data;
      totalBlogs.value = res.data.total;
    } else {
      allBlogs.value = [];
    }
    status.value = 'success';
  } catch (e) {
    status.value = 'error';
    console.log(e);
  }
};

const setFilter = (filterId) => {
  activeFilter.value = filterId;
  page.value = 1;
  fetchBlogs();
};

const clearSearchInput = () => {
  searchQuery.value = '';
};

watch(searchQuery, async (newKey) => {
  await fetchBlogs(newKey);
  page.value = 1;
});

watch(page, async () => {
  await fetchBlogs();
});

onMounted(async () => {
  await fetchBlogs();
});
</script>
